import { Done as DoneIcon } from "@mui/icons-material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { FieldTypes } from "../Modules/FormLogs/FormLogs";
import RenderSignatureFromPaths from "./RenderSignatureFromPaths";

export const getCustomFormValue = (formField, submittedFormData) => {
    const dispatch = useDispatch();

    if (!formField || !submittedFormData) {
        return '';
    }

    let fieldValue = submittedFormData[formField.id];

    if (!fieldValue) {
        return '';
    }

    switch (formField.type) {
        case 'dropdown':
            let options = formField.options.items;
            let selectedOption = options.find((option) => option.value === fieldValue);
            return selectedOption?.label ?? 'Option not found';

        case 'image_upload':
        case 'file_upload':
            return 'Uploaded file';

        case 'checkbox':
            if (fieldValue == 'true' || fieldValue === true) {
                return (
                    <DoneIcon style={{
                        fontSize: '1em',
                        color: 'var(--success-color)'
                    }} />
                );
            } else {
                return (
                    <CloseIcon style={{
                        fontSize: '1em',
                        color: 'var(--warning-color)'
                    }} />
                );
            }

        case FieldTypes.TYPE_IPAD: {
            return (
                <RenderSignatureFromPaths signaturePaths={fieldValue} />
            )
        }

        default:
            return fieldValue;
    }
}
